export default {
  i18nGroups: null,
  i18nValues: null,
  i18nLanguages: null,
  i18nMessages: {},
  i18n: null
}
